import React, { useCallback, useEffect, useState } from "react";
import { useAuthContext } from "../../../context/auth";
import useCountListDown from "../../../hooks/useCountListDown";
import { getMinute } from "../../../utils/getMinute";
import CircularProgress from "../../CircularProgress";

function WarmUp() {
  const {
    circuitProgram,
    basicProgram,
    sendSetStep,
    step,
    emitter,
    index,
    sendCurrentIndex,
  } = useAuthContext();
  const program = basicProgram;

  const videoRef = React.useRef<HTMLVideoElement>(null);
  const { count, start, currentIndex, stop } = useCountListDown(
    program?.warmUpMovements.map((_) => getMinute(_.time)) ?? [],
    useCallback(() => {
      sendCurrentIndex(0);
      sendSetStep(step + 1);
    }, [step, sendSetStep, sendCurrentIndex]),
    true,
    true,
    index
  );

  useEffect(() => {
    start();
    videoRef.current?.play();

    emitter.current.on("resume", () => {
      start();
      console.log("resume");
      videoRef.current?.play();
    });
    emitter.current.on("pause", () => {
      stop();
      console.log("pause");
      videoRef.current?.pause();
    });
    return () => {
      emitter.current.off("resume");
      emitter.current.off("pause");
    };
  }, []);

  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex w-full pl-[70px] pr-[40px] justify-between items-center bg-bg h-[300px]">
        <p className="text-[64px] font-bold text-white">Warm Up</p>
        <div className="w-[270px]">
          <CircularProgress
            maxValue={getMinute(
              program?.warmUpMovements[currentIndex]?.time ?? "00:00"
            )}
            value={count}
          />
        </div>
      </div>
      <div className="flex-1 bg-white h-full relative">
        {program?.warmUpMovements[currentIndex]?.movement.direction !== "X" && (
          <div className="absolute top-[30px] right-[30px]">
            <p className="text-[96px] font-medium text-black">
              {program?.warmUpMovements[currentIndex]?.movement.direction}
            </p>
          </div>
        )}
        <video
          className="w-full h-full object-contain"
          ref={videoRef}
          loop
          autoPlay
          muted
          key={currentIndex}
        >
          <source
            src={program?.warmUpMovements[currentIndex]?.movement.video}
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  );
}

export default WarmUp;
